import { Plugin } from '@nuxt/types'
import createPersistedState from 'vuex-persistedstate'
import Cookies from 'js-cookie'
import cookie from 'cookie'

const localStoragePlugin: Plugin = ({ store, res, req, isDev, env }) => {
  createPersistedState({
    key: 'ga-cookies',
    paths: [
      'auth._sfToken',
      'auth._refreshToken',
      'regions._choiceCity',
      'regions._selectedCityName'
    ],
    storage: {
      getItem: (key) => {
        if (process.client) {
          return Cookies.get(key)
        } else if (req) {
          const parsedCookies = cookie.parse(req.headers.cookie || '')
          return parsedCookies[key]
        } else {
          return null
        }
      },
      setItem: (key, value) => {
        if (process.client) {
          Cookies.set(key, value, {
            expires: 365,
            secure: true,
            domain: `.${env.NUXT_ENV_DOMAIN}`,
            path: '/',
            sameSite: 'none',
          })
        } else if (res && !res.headersSent) {
          const serializedCookie = cookie.serialize(key, value, {
            expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000), 
            secure: true, 
            domain: `.${env.NUXT_ENV_DOMAIN}`,
            path: '/',
            sameSite: 'none'
          })
          res.setHeader('Set-Cookie', serializedCookie)
        }
      },
      removeItem: (key) => {
        if (process.client) {
          Cookies.remove(key, { domain: `.${env.NUXT_ENV_DOMAIN}`, path: '/' })
        } else if (res && !res.headersSent) {
          res.setHeader(
            'Set-Cookie',
            cookie.serialize(key, '', {
              expires: new Date(0),
              domain: `.${env.NUXT_ENV_DOMAIN}`,
              path: '/',
            })
          )
        }
      },
    }
  })(store)
}

export default localStoragePlugin
